



// 



export enum Gender {
    None,
    Female,
    Male
}

export enum MemberAccessActionType {
    Login,
    Search,
    Edit,
    ResetLogin,
    ResetPassword
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/models/enums.ts